export default __webpack_public_path__ + "static/media/top-part-pattern-m.bee7e79f.png";